import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const EmptyReportSection = styled.div`
  margin: 64px;
  padding: 120px 0;
  color: ${globals.THEME.textSecondary};
  text-align: center;
  border: 1px solid ${globals.THEME.border};
`;

export const PanelButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 24px;

  button {
    background: none !important;
    border-radius: 20px !important;

    &:hover {
      background: ${globals.THEME.bgHover};
    }
  }
`;
